export const TaskStatus = {
  ACTIVE: 1,
  DISABLED: 2,
  DELETED: 3,
  NOT_CONFIRMED: 4,
  COMPLETED: 5,
  contains: function (statusId, statuses) {
    if (statuses.includes(statusId)) {
      return true;
    }
    return false;
  },
}